//Node imports
import { dispatcher } from "@quest/base-core";
import { Main, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";

//Game imports
import { eventDispatchers } from "./Constants/EventDispatchers";
import { TopBarViewGame } from "./TopBar/TopBarViewGame";
import { TopBarControllerGame } from "./TopBar/TopBarControllerGame";
import { EventConstantsLeander } from "@quest/oddsworks-platform";
import { EventConstants as PlatformEventConstants } from "@quest/platform-murka/dist";
import { SlotEventConstants } from "@quest/slot-core/dist/SlotConstants/SlotEventDispatchers";
import { ScaleManager } from "@quest/pixi-bridge";


export class MainGame extends Main {

    protected subscribeEvents(): void {
        super.subscribeEvents();
        dispatcher.on(eventDispatchers.RESIZE_CANVAS, this.onSizeChange, this);
    }
    protected unsubscribeEvents() {
        super.subscribeEvents()
        dispatcher.off(eventDispatchers.RESIZE_CANVAS, this.onSizeChange, this);
    }
    /**
     * Function overrided to initialize the basegame magic potion feature
     */
    protected onHideGameIntro(): void {
        super.onHideGameIntro();
        dispatcher.fireEvent(eventDispatchers.INITIALIZE_MAGIC_POTION_BG);
    }
    protected initializeTopBar() {
        const view = new TopBarViewGame(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).topBar);
        new TopBarControllerGame(view);
        ingenuity.currentGame.stage.addChild(view);
    }
    protected initializeBottomBar() {
        //
    }
    protected hideLoader() {
            ingenuity.parserModel.getPromotionalFreeGame() && dispatcher.fireEvent(PlatformEventConstants.PASE_FREE_PLAY_DATA);
            dispatcher.fireEvent(EventConstantsLeander.PRE_LOADING_COMPLETE);
            ingenuity.parserModel.setGameVersion(ingenuity.configData.gameVersionnumber);
            dispatcher.fireEvent(EventConstantsLeander.UPDATE_GAME_VERSION, ingenuity.parserModel.getGameVersion());
            this.resize(); // to handle Button Panel Positions during Slow Networks, as Top Bar and Bottom Bar height comes 0.
            // Event Fired to update BehaviorCore.platformWrapper winamount on game refresh
            dispatcher.fireEvent(SlotEventConstants.LOGIC_ONSTAKE_CHANGE);
            dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_SOUND_POPUP);
            dispatcher.fireEvent(SlotEventConstantsBehavior.LAUNCH_GAME_INTRO);
            dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_POST_LOADER);
            ingenuity.currentGame.onResume.add((evt:any) => {
                this.soundManager && this.soundManager.unmuteAllSounds && this.soundManager.unmuteAllSounds();
            }, this);
            ingenuity.currentGame.onPause.add((evt:any) => {
                this.soundManager && this.soundManager.muteAllSounds && this.soundManager.muteAllSounds();
            }, this);
            if (ingenuity.deviceEnv.isDesktop) {
                ingenuity.currentGame.scale.scaleMode = ScaleManager.RESIZE;
            }
            else {
                ingenuity.currentGame.scale.scaleMode = ScaleManager.SHOW_ALL;
            }
            this.initializeJpAlert();
            dispatcher.fireEvent(eventDispatchers.INITIALIZE_FREE_PLAY_ON_GAME);
            this.loadHelp();
        }
}











